/** The size and format rules, and the desktop-only hint about dropping a file. */
export function PhotoSpecs({ showDropHint }: { showDropHint: boolean }) {
  return (
    <div style={{ fontSize: 11, color: 'var(--nb-muted)', lineHeight: 1.5 }}>
      Landscape works best, ideally 1600 px wide or more. JPEG, PNG or WebP.
      {showDropHint && (
        <>
          <br />
          You can also drop an image onto the preview.
        </>
      )}
    </div>
  );
}
